import { FormControl, Grid, IconButton, TextField, Typography, Autocomplete
    , FormControlLabel, Checkbox, Box, InputLabel, Select, MenuItem, ListItemText } from '@mui/material';
import { Add as IconAdd, Search as IconSearch, AddCircle as IconAddCircle, Edit as IconEdit } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListParticipantes, setListNivelLenguaje, setListColegio, setListGradoColegio, setListTipoSeguro, setListTipoTerapia, defaultParticipante } from "../redux/memberSlice";
import { FormHelperText as HelperText } from '@mui/material';
import DirectionSearch from './DirectionSearch';
import MemberSearch from './PersonSearch';
import MemberRegister from './PersonRegister';
import FatherSearch from './PersonSearch';
import FatherRegister from './PersonRegister';
import MotherSearch from './PersonSearch';
import MotherRegister from './PersonRegister';

const Member = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const participante = useSelector((state) => state.member.participante);
    
    const listParticipantes = useSelector((state) => state.member.listParticipantes);
    //listTerapeutas
    const listNivelLenguaje = useSelector((state) => state.member.listNivelLenguaje);
    const listColegio = useSelector((state) => state.member.listColegio);
    const listGradoColegio = useSelector((state) => state.member.listGradoColegio);
    const listTipoSeguro = useSelector((state) => state.member.listTipoSeguro);
    const listTipoTerapia = useSelector((state) => state.member.listTipoTerapia);

    // const defaultParticipante = useSelector((state) => state.member.defaultParticipante);
    const validate = useSelector((state) => state.member.validationActive);

    const [openDirectionSearch, setOpenDirectionSearch] = useState(false)
    const openCloseDirectionSearch = () => { setOpenDirectionSearch(!openDirectionSearch); }

    const [openSearchMember, setOpenSearchMember] = useState(false)
    const openCloseSearchMember = () => { setOpenSearchMember(!openSearchMember); }
    const [openMemberRegister, setOpenMemberRegister] = useState(false)
    const openCloseMemberRegister = () => { setOpenMemberRegister(!openMemberRegister); }

    const [openSearchFather, setOpenSearchFather] = useState(false)
    const openCloseSearchFather = () => { setOpenSearchFather(!openSearchFather); }
    const [openFatherRegister, setOpenFatherRegister] = useState(false)
    const openCloseFatherRegister = () => { setOpenFatherRegister(!openFatherRegister); }

    const [openSearchMother, setOpenSearchMother] = useState(false)
    const openCloseSearchMother = () => { setOpenSearchMother(!openSearchMother); }
    const [openMotherRegister, setOpenMotherRegister] = useState(false)
    const openCloseMotherRegister = () => { setOpenMotherRegister(!openMotherRegister); }

    const dispatch = useDispatch();
    const fechaIngresoMinimo = new Date(2010, 1, 1);

    var validation = {
        participante: {
            error: participante.participante != null && participante.participante.length < 3,
            message: "Falta ingresar el participante",
        },
        // terapeuta: {
        //     error: participante.terapeuta.length < 3,
        //     message: "Falta ingresar el terapeuta",
        // },
        fechaIngreso: {
            error: Date.parse(participante.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
    }

    useEffect(() => {
        if (participante?.idPersona > 0) {
            props.onPersonaChange(participante.idPersona);
        }
    }, [participante?.idPersona]);

    const fetchParticipante = useCallback(async () => {
        const response = await api.get("/Participante/GetParticipanteViewById?idParticipante=" + params.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        // Si el participante no existe se cargan los valores por defecto: dejar el
        // entidad en null hacia fallar la pantalla.
        if (params.id == 0 || !response?.data?.data)
            dispatch(setEntity(defaultParticipante));
        else
            dispatch(setEntity(response.data.data));
    }, [params.id])
    const fetchListParticipantes = useCallback(async () => {
        const response = await api.get("/Persona/GetsListNaturalPersonByTypeAndName?idType=24&name=")
            .catch((err) => {
                console.log("Err: ", err);
            });
        
        dispatch(setListParticipantes(response.data.data));
    }, [])
    const fetchListNivelLenguaje = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=111")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListNivelLenguaje(response.data.data));
    }, [])
    const fetchListColegio = useCallback(async () => {
        const response = await api.get("/Persona/GetsListLegalPersonByTypeAndName?idType=100&name=")
            .catch((err) => {
                console.log("Err: ", err);
            });
        
        dispatch(setListColegio(response.data.data));
    }, [])
    const fetchListGradoColegio = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=118")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListGradoColegio(response.data.data));
    }, [])
    const fetchListTipoSeguro = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=130")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListTipoSeguro(response.data.data));
    }, [])
    const fetchListTipoTerapia = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=133")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListTipoTerapia(response.data.data));
    }, [])

    useEffect(() => {
        fetchParticipante();
        fetchListParticipantes();
        fetchListNivelLenguaje();
        fetchListColegio();
        fetchListGradoColegio();
        fetchListTipoSeguro();
        fetchListTipoTerapia();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [participante])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    const setSelectDirectionSearch = (select) => {
        dispatch(setData({name: "idDireccionCasoAccidente", value: select.id}));
        dispatch(setData({name: "ubigeoCasoAccidente", value: select.ubigeo}));
        dispatch(setData({name: "direccionCasoAccidente", value: select.detalle}));
    }
    const setMemberNew = (id, name) => {
        dispatch(setData({name: "idPersona", value: id}));
        dispatch(setData({name: "participante", value: name}));

        props.onPersonaChange(id);
    }
    const setMemberFound = (select) => {
        dispatch(setData({name: "idPersona", value: select.idPersona}));
        dispatch(setData({name: "participante", value: select.nombres}));

        props.onPersonaChange(select.idPersona);
    }
    const setFatherNew = (id, name) => {
        dispatch(setData({name: "idPadre", value: id}));
        dispatch(setData({name: "padre", value: name}));
    }
    const setFatherFound = (select) => {
        dispatch(setData({name: "idPadre", value: select.idPersona}));
        dispatch(setData({name: "padre", value: select.nombres}));
    }
    const setMotherNew = (id, name) => {
        dispatch(setData({name: "idMadre", value: id}));
        dispatch(setData({name: "madre", value: name}));
    }
    const setMotherFound = (select) => {
        dispatch(setData({name: "idMadre", value: select.idPersona}));
        dispatch(setData({name: "madre", value: select.nombres}));
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(participante)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={12} sm={4}>
                    <Box display="flex" alignItems="center" gap={0}>
                        <FormControl required fullWidth error={validate.participante && validation.participante.error}>
                            {/* <Autocomplete
                                name="idPersona"
                                value={participante.idPersona == null ? 0 : participante.idPersona}
                                inputValue={participante.participante == null ? "" : participante.participante}
                                onInputChange={(event, newValue) => {
                                    if (event != null) {
                                        if (event.type === "change") {
                                            dispatch(setData({name: "participante", value: newValue == null ? "" : newValue}))
                                        }
                                    }
                                }}
                                onChange={(event, newValue) => {
                                    dispatch(setData({name: "idPersona", value: newValue == null ? 0 : newValue.id}))
                                    dispatch(setData({name: "participante", value: newValue == null ? "" : newValue.descripcion}))
                                }}
                                options={listParticipantes}
                                autoHighlight
                                getOptionLabel={(option) => option.descripcion == null ? "" : option.descripcion}
                                isOptionEqualToValue ={(option, value) => option.value === value.value}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.id}>
                                        {option.descripcion}
                                        </li>
                                    );
                                    }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Participante"
                                        variant="outlined"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password',
                                        }}
                                    />
                                )}
                                size="small"
                            /> */}
                            <TextField
                                disabled
                                name="participante"
                                label="Participante"
                                value={participante.participante}
                                fullWidth
                                // onChange={(event) => {
                                //     setItemValue(row.numero, "personaVinculo", event.target.value)
                                // }}
                                size="small"
                            />
                            <HelperText>{validate.participante && validation.participante.error ? validation.participante.message : ""}</HelperText>
                        </FormControl>
                        <IconButton aria-label="Buscar Participante" size='small' disabled={isReadOnly} onClick={() => {
                            openCloseSearchMember()
                        }}>
                            <IconSearch />
                        </IconButton>
                        <IconButton aria-label="Registrar Participante" size='small' disabled={isReadOnly} onClick={() => {
                            openCloseMemberRegister()
                        }}>
                            {participante.idPersona > 0 ? <IconEdit /> : <IconAddCircle />}
                        </IconButton>
                    </Box>
                </Grid>
                {/* <Grid item xs={2} sm={1}>
                </Grid> */}
                {/* <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.terapeuta && validation.terapeuta.error}>
                        <Autocomplete
                            name="idTerapeuta"
                            value={participante.idTerapeuta == null ? 0 : participante.idTerapeuta}
                            inputValue={participante.terapeuta == null ? "" : participante.terapeuta}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setData({name: "terapeuta", value: newValue == null ? "" : newValue}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "idTerapeuta", value: newValue == null ? 0 : newValue.id}))
                                dispatch(setData({name: "terapeuta", value: newValue == null ? "" : newValue.descripcion}))
                            }}
                            options={listTerapeutas}
                            autoHighlight
                            getOptionLabel={(option) => option.descripcion == null ? "" : option.descripcion}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Terapeuta"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText>
                    </FormControl>
                </Grid> */}
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="fechaIngreso"
                        label="Fecha Ingreso"
                        fullWidth
                        type="date"
                        //defaultValue={moment()}
                        value={moment(participante.fechaIngreso).format('yyyy-MM-DD')}
                        onChange={setDataEntity}
                        error={validate.fechaIngreso && validation.fechaIngreso.error}
                        helperText={validate.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                {/* <Grid item xs={6} sm={4}>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-nivellenguaje">Nivel Lenguaje</InputLabel>
                        <Select
                            // native
                            label="nivelLenguaje"
                            multiple
                            value={[participante?.idNivelLenguaje] || [0]}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idNivelLenguaje',
                                id: 'input-nivellenguaje',
                            }}
                            size="small"
                        >
                            {listNivelLenguaje.map((op) => (
                            <MenuItem key={op.id} value={op.id}>
                                <Checkbox checked={seleccionados.includes(op.id)} />
                                <ListItemText primary={op.descripcion} />
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid> */}
                <Grid
                    item
                    xs={false}
                    sm={4}
                    display={{ xs: "none", sm: "block" }}
                />
                <Grid item xs={12} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneEscolaridad"
                            checked={participante.tieneEscolaridad}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneEscolaridad", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Escolaridad" />    
                </Grid>
                <Grid item xs={6} sm={4}>
                    {/* <FormControl required fullWidth error={validate.terapeuta && validation.terapeuta.error}>*/}
                    <FormControl required fullWidth>
                        <Autocomplete
                            name="idColegio"
                            value={listColegio.find(x => x.id === participante.idColegio) || null}
                            inputValue={participante.colegio || ""}
                            onInputChange={(event, newValue) => {
                                if (event != null) {
                                    if (event.type === "change") {
                                        dispatch(setData({name: "colegio", value: newValue || ""}))
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "idColegio", value: newValue?.id ?? 0}))
                                dispatch(setData({name: "colegio", value: newValue?.descripcion ?? ""}))
                            }}
                            options={listColegio}
                            autoHighlight
                            disabled={isReadOnly}
                            getOptionLabel={(option) => option.descripcion || ""}
                            isOptionEqualToValue ={(option, value) => option.value === value.value}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                    {option.descripcion}
                                    </li>
                                );
                                }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Colegio"
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password',
                                    }}
                                />
                            )}
                            size="small"
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-gradocolegio">Grado Colegio</InputLabel>
                        <Select
                            native
                            label="gradocolegio"
                            value={participante?.idGradoColegio || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idGradoColegio',
                                id: 'input-gradocolegio',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listGradoColegio?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneSeguro"
                            checked={participante.tieneSeguro}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneSeguro", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Seguro" />
                </Grid>
                <Grid item xs={6} sm={4}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-tiposeguro">Tipo Seguro</InputLabel>
                        <Select
                            native
                            label="tiposeguro"
                            value={participante?.idTipoSeguro || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTipoSeguro',
                                id: 'input-tiposeguro',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipoSeguro?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="detalleSeguro"
                        label="Detalle Seguro"
                        fullWidth
                        value={participante.detalleSeguro}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneHermanos"
                            checked={participante.tieneHermanos}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneHermanos", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Hermanos" />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <TextField
                        name="detalleHermanos"
                        label="Detalle Hermanos"
                        fullWidth
                        value={participante.detalleHermanos}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        name="detalleConvivencia"
                        label="Detalle Convivencia"
                        fullWidth
                        value={participante.detalleConvivencia}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneDiagnostico"
                            checked={participante.tieneDiagnostico}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneDiagnostico", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Diagnostico" />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="fechaUltimoDiagnostico"
                        label="Fecha Ult. Diagnostico"
                        fullWidth
                        type="date"
                        //defaultValue={moment()}
                        value={moment(participante.fechaUltimoDiagnostico).format('yyyy-MM-DD')}
                        onChange={setDataEntity}
                        // error={validate.fechaUltimoDiagnostico && validation.fechaUltimoDiagnostico.error}
                        // helperText={validate.fechaUltimoDiagnostico && validation.fechaUltimoDiagnostico.error ? validation.fechaUltimoDiagnostico.message : ""}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid
                    item
                    xs={false}
                    sm={6}
                    display={{ xs: "none", sm: "block" }}
                />
                <Grid item xs={12} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="asisteATerapia"
                            checked={participante.asisteATerapia}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "asisteATerapia", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Asiste a Terapia" />
                </Grid>
                <Grid item xs={6} sm={3}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                        <Select
                            native
                            label="tipoterapia"
                            value={participante?.idTipoTerapia || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTipoTerapia',
                                id: 'input-tipoterapia',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipoTerapia?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                {/* <Grid item xs={6} sm={2}>
                    <TextField
                        disabled
                        name="ubigeoCasoAccidente"
                        label="Ubigeo"
                        value={participante.ubigeoCasoAccidente}
                        fullWidth
                        // onChange={(event) => {
                        //     dispatch(setData({name: "ubigeoCasoAccidente", value: event.target.value}));
                        // }}
                        size="small"
                    />
                </Grid> */}
                <Grid
                    item
                    xs={false}
                    sm={6}
                    display={{ xs: "none", sm: "block" }}
                />
                <Grid item xs={12} sm={5}>
                    <TextField
                        required
                        name="lugarCasoAccidente"
                        label="Lugar Caso Accidente"
                        fullWidth
                        value={participante.lugarCasoAccidente}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>

                <Grid item xs={12} sm={5}>
                    <Box display="flex" alignItems="center" gap={0}>
                        <TextField
                            disabled
                            required
                            name="direccionCasoAccidente"
                            label="Direcccion"
                            value={participante.direccionCasoAccidente}
                            fullWidth
                            // onChange={(event) => {
                            //     setItemValue(row.numero, "direccionCasoAccidente", event.target.value);
                            // }}
                            size="small"
                        />
                        <IconButton aria-label="Buscar Direccion" disabled={isReadOnly} onClick={() => {
                            openCloseDirectionSearch()
                        }}>
                            <IconSearch />
                        </IconButton>
                    </Box>
                </Grid>
                {/* <Grid item xs={12} sm={3}>
                    <TextField
                        disabled
                        name="padre"
                        label="Padre"
                        fullWidth
                        value={participante.padre}
                        size="small"
                    />
                </Grid>
                <Grid item xs={2} sm={1}>
                    <IconButton aria-label="Buscar Padre" size='small' onClick={() => {
                        openCloseSearchFather()
                    }}>
                        <IconSearch />
                    </IconButton>
                    <IconButton aria-label="Registrar Padre" size='small' onClick={() => {
                        openCloseFatherRegister()
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        disabled
                        name="madre"
                        label="Madre"
                        fullWidth
                        value={participante.madre}
                        size="small"
                    />
                </Grid>
                <Grid item xs={2} sm={1}>
                    <IconButton aria-label="Buscar Madre" size='small' onClick={() => {
                        openCloseSearchMother()
                    }}>
                        <IconSearch />
                    </IconButton>
                    <IconButton aria-label="Registrar Madre" size='small' onClick={() => {
                        openCloseMotherRegister()
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Grid> */}
            </Grid>
            <DirectionSearch open={openDirectionSearch} openClose={openCloseDirectionSearch} setSelection={setSelectDirectionSearch} />
            <MemberSearch open={openSearchMember} openClose={openCloseSearchMember} setSelection={setMemberFound} />
            <MemberRegister key={participante.idPersona} id={participante.idPersona} sliceKey="memberRegister" idTipoPersona={0} tipoPersona="" hideInputs={true} open={openMemberRegister} openClose={openCloseMemberRegister} setNewPersonSaved={setMemberNew} />
            <FatherSearch open={openSearchFather} openClose={openCloseSearchFather} setSelection={setFatherFound} />
            <FatherRegister idTipoPersona={23} tipoPersona="Padre" open={openFatherRegister} openClose={openCloseFatherRegister} setNewPersonSaved={setFatherNew} />
            <MotherSearch open={openSearchMother} openClose={openCloseSearchMother} setSelection={setMotherFound} />
            <MotherRegister idTipoPersona={93} tipoPersona="Madre" open={openMotherRegister} openClose={openCloseMotherRegister} setNewPersonSaved={setMotherNew} />
        </Grid>
    );
}
export default Member;
